import {ConfigText} from 'components/common/ConfigText'
import {OrderProvider} from 'providers/OrderProvider'
import {AdyenForm} from './AdyenForm'
import {Contact} from './Contact'

type Props = {
  ready: boolean
  onReady: () => void
}

export const View = ({ready, onReady}: Props) => {
  const order = OrderProvider.useOrder()

  if (!order.cardPayment) {
    throw new Error('Card payment is not defined')
  }

  if (order.cardPayment.gateway !== 'adyen') {
    throw new Error('Card payment gateway is not supported')
  }

  return <ViewAdyenGateway ready={ready} onReady={onReady} />
}

const ViewAdyenGateway = ({onReady}: Props) => {
  return (
    <div className="flex flex-col gap-6">
      <Contact />

      <div className="flex flex-col gap-2">
        <p>
          <ConfigText
            configKey="paymentInstruction"
            defaultText="Please enter your card information to reserve your spot on the tour."
          />
        </p>
      </div>

      <div>
        <AdyenForm onReady={onReady} />
      </div>
    </div>
  )
}
